import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './meeting-simple.types';
import { authSelectors } from '../../auth/auth.selectors';
import { userSelectors } from '../user/user.selectors';
import { isMemberPartOfMeeting } from '../../../utils/user.utils';
import { IAppState } from '../../app.types';

export const meetingSimpleSelectors = {
  ...generateResourceSelectors<types.IMeetingSimple>((state) => state.resource.meetingSimple),
  selectMeetingsLoggedUserIsPartOf: (state: IAppState): types.IMeetingSimple[] => {
    const loggedUserId = authSelectors.selectLoggedUser(state);
    const loggedUser = userSelectors.selectResourceById(state, loggedUserId ?? '');
    const meetings = meetingSimpleSelectors.selectResourceList(state);
    let filteredMeetings = meetings;
    if (loggedUser) {
      filteredMeetings = meetings.filter((meeting) => isMemberPartOfMeeting(loggedUser, meeting));
    }
    return filteredMeetings;
  },
};
